import { BundlePricings } from 'src/hooks/useDCS';

export function isSelfServicePurchaseEnabled(pricings: BundlePricings | undefined): boolean {
  return !!pricings?.isSelfServicePurchaseEnabled &&
    pricings.includedProducts.every(({ product }) => product.isSelfServicePurchaseEnabled);
}
